// The host hides the assistant with display:none, so the app keeps running in the hidden iframe. Anything
// that must not outlive the visible panel, such as an open microphone, ends itself here.
const listeners = new Set<() => void>();

export const onPanelHidden = (listener: () => void): (() => void) => {
    listeners.add(listener);
    return () => {
        listeners.delete(listener);
    };
};

export const notifyPanelHidden = (): void => {
    listeners.forEach((listener) => {
        listener();
    });
};
